import React, { useEffect, useRef, useState } from 'react';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/react-editor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { auth, db } from '../../components/firebase';
import { doc, getDoc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { useParams } from 'react-router-dom';
import { template } from '../../constants';

const OutputSection = ({ aiOutput, userFormInput, toolSlug }) => {
  const weburl = useParams();
  const editorRef = useRef();
  const [usersUid, setUsersUid] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchUserData = (user) => {
    if (user) {
      setUsersUid(user.uid);
    }
  };

  useEffect(() => {
    const editorInstance = editorRef.current.getInstance();
    editorInstance.setMarkdown(aiOutput);
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        fetchUserData(user);
      } else {
        console.error("No user authenticated.");
      }
    });
    return () => unsubscribe();
  }, [aiOutput]);

  useEffect(() => {
    const storeToDB = async () => {
      const historydata = template.filter((e) => e.slug === weburl.slug);
      if (usersUid && aiOutput && toolSlug) {
        const toolRef = doc(db, "Users", usersUid, "Tools", toolSlug);
        try {
          const formattedDate = new Date().toLocaleDateString('en-GB');
          const entry = {
            name: historydata[0].name,
            Output: aiOutput,
            date: formattedDate,
            slug: toolSlug,
            image: historydata[0].icon,
          };
          const docSnap = await getDoc(toolRef);
          if (docSnap.exists()) {
            await updateDoc(toolRef, {
              entries: arrayUnion(entry)
            });
          } else {
            await setDoc(toolRef, {
              entries: [entry]
            });
          }
        } catch (error) {
          console.error("Error saving data to Firestore:", error);
        }
      }
    };

    storeToDB();
  }, [aiOutput, usersUid, toolSlug]);

  const shareContent = (platform) => {
    const editorContent = editorRef.current.getInstance().getMarkdown();
    const shareText = encodeURIComponent(editorContent);
    let shareUrl = '';
    if (platform === 'linkedin') {
      shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${shareText}`;
    } else if (platform === 'whatsapp') {
      shareUrl = `https://wa.me/?text=${shareText}`;
    }

    const shareWindow = window.open(
      shareUrl,
      '_blank',
      `width=600,height=400,top=${window.innerHeight / 2 - 200},left=${window.innerWidth / 2 - 300}`
    );

    if (!shareWindow) {
      alert('Popup blocked. Please enable popups for this website.');
    }
  };

  return (
    <div className='bg-white shadow-lg border rounded-lg'>
      <div className='flex flex-col sm:flex-row justify-between items-center p-5'>
        <h2 className='text-lg font-semibold text-blue-700 mb-4 sm:mb-0'>Your Result</h2>
        <div className='flex flex-col sm:flex-row gap-2'>
          <button
            className='text-base w-full sm:w-auto bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 text-white font-semibold py-2 px-4 rounded-md shadow-md hover:opacity-90 transition-opacity'
            onClick={() => setIsModalOpen(true)}>
            <FontAwesomeIcon icon={faShareAlt} className='mr-2' /> Share
          </button>
          <button
            className='text-base w-full sm:w-auto bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 text-white font-semibold py-2 px-4 rounded-md shadow-md hover:opacity-90 transition-opacity'
            onClick={() => navigator.clipboard.writeText(editorRef.current.getInstance().getMarkdown())}>
            <FontAwesomeIcon icon={faCopy} className='mr-2' /> Copy
          </button>
        </div>
      </div>
      <Editor ref={editorRef} initialValue="Your result will appear here" initialEditType="wysiwyg" height="600px" useCommandShortcut={true} />

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl transform scale-95 transition-transform duration-300 ease-out p-6 w-11/12 max-w-lg relative">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              onClick={() => setIsModalOpen(false)}
            >
              <FontAwesomeIcon icon={faTimes} size="lg" />
            </button>
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Share Your Result</h3>
            <p className="text-gray-600 mb-6 text-center">
              Choose a platform to share your content. Your text will be shared directly!
            </p>
            <div className="flex justify-around">
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md shadow-md transition-all duration-200"
                onClick={() => {
                  shareContent('linkedin');
                  setIsModalOpen(false);
                }}
              >
                <FontAwesomeIcon icon={faLinkedin} className="mr-2" /> LinkedIn
              </button>
              <button
                className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-md shadow-md transition-all duration-200"
                onClick={() => {
                  shareContent('whatsapp');
                  setIsModalOpen(false);
                }}
              >
                <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OutputSection;
